var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5301 17.5036C19.0701 17.5036 20.0301 15.8336 19.2601 14.5036L11.7301 1.49359C10.9601 0.163594 9.04012 0.163594 8.27012 1.49359L0.740121 14.5036C-0.0298788 15.8336 0.930121 17.5036 2.47012 17.5036H17.5301ZM10.0001 10.5036C9.45012 10.5036 9.00012 10.0536 9.00012 9.50359V7.50359C9.00012 6.95359 9.45012 6.50359 10.0001 6.50359C10.5501 6.50359 11.0001 6.95359 11.0001 7.50359V9.50359C11.0001 10.0536 10.5501 10.5036 10.0001 10.5036ZM9.00012 12.5036V14.5036H11.0001V12.5036H9.00012Z",
    fill: "#C43E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e870cbf549f0c24e85a5383b179f9ee6.svg";
export { ForwardRef as ReactComponent };